import { queryOptions } from "@tanstack/react-query";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import {
  normalizeProjectSuggestionList,
  type ProjectSuggestionListParams,
  type ProjectSuggestionPage,
  projectSuggestionListResponseSchema,
} from "../types";
import { projectSuggestionsKeys } from "./query-keys";

export const fetchProjectSuggestions = async ({
  client,
  params = {},
}: {
  client: ApiClient;
  params?: ProjectSuggestionListParams;
}): Promise<ProjectSuggestionPage> => {
  const { data } = await client.get<unknown>("/suggestions", {
    params: {
      gateway_id: params.gateway_id,
      query: params.query,
      suggestion_submitter: params.suggestion_submitter,
      show_resolved: params.show_resolved,
      limit: params.limit,
      offset: params.offset,
    },
  });

  return normalizeProjectSuggestionList(
    projectSuggestionListResponseSchema.parse(data)
  );
};

export const projectSuggestionsQueryOptions = ({
  scope,
  params = {},
}: {
  scope: OrgProjectScope;
  params?: ProjectSuggestionListParams;
}) => {
  const client = getEngineApi(scope, "project");

  return queryOptions({
    queryKey: projectSuggestionsKeys.list(scope, params),
    queryFn: () => fetchProjectSuggestions({ client, params }),
  });
};
